// 生成固定长度随机妈（含数字和大小写字母
function getFixedRandomCode(length) {
  if (length > 0) {
     var data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
     var nums = "";

     for (var i = 0; i < length; i++) {
        var r = parseInt(Math.random() * 61);
        nums += data[r];
     }

     return nums;
  } else {
     return false;
  }
}

function formatSeconds(value,noAdd) {
   var secondTime = Math.round(value); // 秒
   var minuteTime = 0;// 分
   var hourTime = 0;// 小时
   var formatTimeObj = {};

   if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
     //获取分钟，除以60取整数，得到整数分钟
     minuteTime = parseInt(secondTime / 60);
     //获取秒数，秒数取佘，得到整数秒数
     secondTime = parseInt(secondTime % 60);
     //如果分钟大于60，将分钟转换成小时
     if(minuteTime >= 60) {
       //获取小时，获取分钟除以60，得到整数小时
       hourTime = parseInt(minuteTime / 60);
       //获取小时后取佘的分，获取分钟除以60取佘的分
       minuteTime = parseInt(minuteTime % 60);
     }
   }

   var sec = parseInt(secondTime);

   if (noAdd) {
     formatTimeObj.s = sec + '';
   } else {
     formatTimeObj.s = sec > 9 ? sec + '' : '0' + sec;
   }

   if(minuteTime > 0) {
     var min = parseInt(minuteTime);

     if (!noAdd) {
       min = min > 9 ? min : '0' + min;
     }

     formatTimeObj.m = min + '';
   } else {
     formatTimeObj.m = '00';
   }

   if(hourTime > 0) {
     var hour = parseInt(hourTime);

     if (!noAdd) {
       hour = hour > 9 ? hour : '0' + hour;
     }

     formatTimeObj.h = hour + '';
   }

   return formatTimeObj;
 }

function timestampFormatToYMD(timestamp) {
  let timeDate = new Date(timestamp);
	let Y = timeDate.getFullYear();
	let m = timeDate.getMonth()+1;
	let d	=	timeDate.getDate();
	
	return Y + '' + m + '' + d;
}

function isToday(timestamp) {
  let curTime = new Date().getTime();
	let curYMD = timestampFormatToYMD(curTime);
	let comparisonYMD = timestampFormatToYMD(timestamp || curTime);

	return curYMD === comparisonYMD;
}

function getCurrnetTimestamp() {
  let currentTimestamp = new Date().getTime();

  return currentTimestamp
}

function getUploadFileNameList(uploadList) {
  if (!uploadList || !uploadList.length) {
    return;
  }

  let fileList = [];

  uploadList.forEach((item,index) => {
    if (item && item.type == 'image') {
      fileList.push(item.fileName);
    }
  });

  return fileList;
}

function getCurrentTimestampRandomCode(codeNumber = 5) {
  let currentTimestamp = new Date().getTime();
  let randomCode = getFixedRandomCode(codeNumber);
  let timeRandomCode = currentTimestamp + '' + randomCode;

  return timeRandomCode;
}

function getOssVideoFirstFramePicture(videoUrl) {
  return videoUrl + '?x-oss-process=video/snapshot,t_10000,m_fast';
}

function assign(target, ...args) {
  if (target === undefined || target === null) {
    throw new TypeError(`Cannot convert undefined or null to object.`);
  }

  const to = Object(target);

  args.forEach(source => {
    if (source !== undefined && source !== null) {
      Object.keys(source).forEach(key => {
        to[key] = source[key];
      });
    }
  });

  return to;
}


function AsyncFunc(func, delay) {
  let _timer;
  return (function _delay(timeout) {
    function _func() {
      const args = arguments;
      clearTimeout(_timer);
      _timer = setTimeout(function () {
        func.apply(null, args);
      }, timeout || 0);
    }
    _func.delay = _delay;
    _func.cancel = function () {
      clearTimeout(_timer);
    };
    return _func;
  })(delay || 0);
};

function dealShowTotaltime(time, returnStr) {
  if (time <= 0) {
    return returnStr;
  }

  const hours = parseInt(time / 3600)
  const minute = parseInt(time / 60 % 60)
  const second = Math.ceil(time % 60)

  return `${hours > 0 ? `${hours}时` : ''}${minute > 0 ? minute + '分' : ''}${second > 0 ? second+'秒' : ''}`
}

function systemType() {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;


  return isAndroid ? 'android' : 'ios';
}

function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase();

  if (ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  } else {
    return false;
  }
}

function getFullHttpUrl() {
  return window.location.href;
}

function getDomainUrl() {
  const protocol = window.location.protocol;
  const host = window.location.host;

  return protocol +'//' + host;
}

function getWXAuthUrl(appid,stateStr) {
  let backUrl = window.location.href;
  let empowerUrl = encodeURI(backUrl);
  let wxScope = "snsapi_base"; // 1、snsapi_base   2、snsapi_userinfo

  return "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid +
  "&redirect_uri=" +
  empowerUrl +
  "&response_type=code&scope=" +
  wxScope +
  "&state=" +
  stateStr +
  "#wechat_redirect";
}


export {
  getCurrentTimestampRandomCode,
  getOssVideoFirstFramePicture,
  getUploadFileNameList,
  getCurrnetTimestamp,
  getFixedRandomCode,
  formatSeconds,
  AsyncFunc,
  isToday,
  assign,
  dealShowTotaltime,
  systemType,
  isWeiXin,
  getFullHttpUrl,
  getDomainUrl,
  getWXAuthUrl,
};


// WEBPACK FOOTER //
// ./src/utils/utils.js